export default "__VITE_ASSET__CVr0qbTI__"